export const numberAndSpecialCharacters = (value: string) => {
  if (!value || typeof value !== 'string') {
    return { value };
  }
  return {
    value: value?.replace(/[^0-9\.\^\$\*\+\-\?\(\)\[\]\{\}\\|\—\/]+/, ''),
  };
};
